module.exports = __webpack_public_path__ + "img/tooltip_05-vallone-aure.5fb4d48c.jpg";